import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { SvgIconModule } from 'shared/components/svg-icon/svg-icon.module';
import { AgentStatsComponent } from './agent-stats.component';
import { DetailedAgentStatModule } from './detailed-agent-stat/detailed-agent-stat.module';
import { CompactAgentStatModule } from './compact-agent-stat/compact-agent-stat.module';
import { AgentStatsService } from './services/agent-stats.service';
import { StatService } from './services/agent-stat.service';
import { StatSourceService } from './services/stat-source.service';
import { TriggerService } from './services/trigger.service';
import { TooltipModule } from 'shared/components/tooltip/tooltip.module';

@NgModule({
  imports: [
    CommonModule,
    SvgIconModule,
    TranslateModule.forChild(),
    DetailedAgentStatModule,
    CompactAgentStatModule,
    TooltipModule
  ],
  declarations: [
    AgentStatsComponent
  ],
  providers: [
    AgentStatsService,
    StatService,
    StatSourceService,
    TriggerService
  ],
  exports: [
    AgentStatsComponent
  ]
})
export class AgentStatsModule {}
